import { useState } from 'react'
import { Outlet } from 'react-router-dom'

import { useListStateReset } from '@/hooks/use-list-state-reset'

import { Header } from './Header'
import { Sidebar } from './Sidebar'

export function AppLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  useListStateReset()

  return (
    <div className="h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      <Header
        onMenuClick={() => {
          setIsSidebarOpen(!isSidebarOpen)
        }}
      />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => {
            setIsSidebarOpen(false)
          }}
        />

        <main id="main-content" className="flex-1 overflow-x-hidden overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
